import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PurityConfigurationForm from '../../../../components/masters/metalPurity/purityConfiguration/PurityConfigurationForm';
import PurityConfigurationTable from '../../../../components/masters/metalPurity/purityConfiguration/PurityConfigurationTable';
import { fetchPurityConfigurations, addPurityConfiguration, updatePurityConfiguration, deletePurityConfiguration, setPurityConfigurationEdit, clearPurityConfigurationEdit } from '../../../../redux/actions/masters/metalPurity/purityConfiguration/purityConfigurationAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';
import { fetchMetalTypes } from '../../../../api/masters/metalPurity/metaltype/metalTypeApi';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .purity-configuration-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .purity-configuration-form, .purity-configuration-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const PurityConfigurationPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingPurityConfiguration, formSuccess, formError } = useSelector(state => state.purityConfiguration || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [metalTypes, setMetalTypes] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchPurityConfigurations());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
    fetchMetalTypes().then(data => setMetalTypes(data.filter(m => m.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearPurityConfigurationEdit());
  };

  const handleSubmit = async (form) => {
    if (editingPurityConfiguration && editingPurityConfiguration.purity_configuration_id) {
      await dispatch(updatePurityConfiguration(editingPurityConfiguration.purity_configuration_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addPurityConfiguration(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (purityConfiguration) => {
    dispatch(setPurityConfigurationEdit(purityConfiguration));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deletePurityConfiguration(id));
  };

  const handleCancel = () => {
    dispatch(clearPurityConfigurationEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      pc => pc.metal_purity_code === code && (!excludeId || pc.purity_configuration_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="purity-configuration-flex">
        <div style={tableContainer} className="purity-configuration-table">
          <PurityConfigurationTable
            onNew={handleFormReset}
            purityConfigurations={list}
            metalTypes={metalTypes}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="purity-configuration-form">
          <PurityConfigurationForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingPurityConfiguration={editingPurityConfiguration}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            metalTypes={metalTypes}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default PurityConfigurationPage; 